import Layout from "../../layout/main";
import CustomerMyOrganization from "../../components/customerMyOrganization";
/**
 * CustomerMyOrganizationPage
 *
 * صفحه مدیریت سازمان مشتری که اطلاعات مربوط به سازمان مشتری را نمایش می‌دهد.
 * این صفحه از Layout اصلی برای ساختار کلی استفاده می‌کند.
 *
 * ویژگی‌ها:
 * - استفاده از Layout برای ساختار و استایل کلی اپلیکیشن
 * - نمایش کامپوننت CustomerMyOrganization که اطلاعات سازمان مشتری را ارائه می‌دهد
 *
 * @returns JSX.Element
 */
const CustomerMyOrganizationPage = () => {
  return (
    <Layout>
      <CustomerMyOrganization />
    </Layout>
  );
};

export default CustomerMyOrganizationPage;
